module.exports = __webpack_public_path__ + "static/media/TS Logo.6694533d.png";